var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 70.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 63.5,
    fill: "#7E42FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3927 104.545C71.8153 105.401 70.6692 105.782 69.6779 105.782C68.6796 105.782 67.5666 105.404 65.9631 104.517C39.2101 89.7366 39.2988 81.6409 39.6274 51.5174C39.6605 48.5226 39.6953 45.3261 39.7057 41.9018C43.8501 40.6739 48.2814 39.5157 52.904 38.4548C57.9527 37.2948 63.5683 36.5453 69.5909 36.2235C81.0501 37.4948 89.8396 39.1713 99.3596 41.9174C99.377 45.787 99.4275 49.3609 99.4709 52.6722C99.8866 82.9505 99.9874 90.1452 73.3927 104.545ZM104.688 52.6009C104.636 48.7574 104.579 44.5644 104.57 39.9592C104.568 38.8096 103.812 37.7957 102.709 37.467C92.0796 34.2774 82.5909 32.4079 69.9527 31.0148C69.8135 30.9992 69.6727 30.9974 69.5335 31.0026C63.1266 31.3331 57.1388 32.1296 51.7353 33.3696C46.2988 34.6183 41.1144 35.9992 36.3318 37.4722C35.2396 37.8079 34.4918 38.82 34.4918 39.9644C34.4918 44.1087 34.4483 47.9244 34.4118 51.46C34.0814 81.54 33.9579 92.7957 63.4396 109.084C65.8709 110.427 67.737 110.999 69.6779 110.999C71.584 110.999 73.497 110.424 75.8779 109.135C105.247 93.2287 105.118 83.8096 104.688 52.6009ZM87.968 53.7623L64.4445 77.3745L52.8967 65.7866C51.5419 64.4284 49.3384 64.4232 47.9767 65.778C46.6167 67.1345 46.6132 69.3362 47.968 70.6979L61.9801 84.7588C62.6341 85.4127 63.5193 85.7814 64.4445 85.7814C65.3697 85.7814 66.2567 85.4127 66.9088 84.7571L92.8967 58.6701C94.2515 57.3101 94.248 55.1066 92.8862 53.7519C91.528 52.3971 89.3228 52.3988 87.968 53.7623Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar4);
export default __webpack_public_path__ + "static/media/avatar4.2cab6c9c193b97c43665313379a33b87.svg";
export { ForwardRef as ReactComponent };